import groupBy from "lodash/groupBy";
import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import ToolTip from "../../../../parts/tooltip";
import DateInput from "../../../../parts/inputs/date-input";
import moment from "moment";
import submit from "submit-form";
import { getAthleteFromId } from "../../../coaching-portal/tasks/task-constants";
import SvgIcon from "../../../../parts/SvgIcon";
import { RillContext } from "../../../../rill/RillReact/share/base";

class ConfirmPush extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      submited: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.submited) return;
    this.setState({ submited: true });
    const { query, coachOrganizationInformation, activeUser } =
      this.context.locals;
    const { athlete, cycle, program } = query;
    const date = document.getElementsByName("date")[0].value;
    const obj = { method: "POST" };
    if (date) {
      obj.body = { date };
    }

    const athleteForTask = !!coachOrganizationInformation
      ? getAthleteFromId(athlete, coachOrganizationInformation.athletes)
      : getAthleteFromId(athlete, activeUser.athletes);
    if (athleteForTask) {
      obj.body = { ...obj.body, athleteForTask };
    }

    submit(
      `/actions/cycle/push/${String(cycle)}/${String(program)}/${String(
        athlete
      )}`,
      obj
    );
  }

  render() {
    const { fullProgram, athlete: ath, clientOnProgram, t } = this.props;
    const { activeUser } = this.context.locals;
    const referAsClients = Boolean(activeUser.referAsClients);
    const role = referAsClients
      ? t("athlete-portal:programs.client")
      : t("athlete-portal:programs.athlete");
    let defaultDate = moment.utc();
    if (fullProgram && fullProgram.sessions) {
      const weeks = groupBy(fullProgram.sessions, "week");
      defaultDate = defaultDate.add(Object.keys(weeks).length, "weeks");
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <Modal
          className="Confirm-Push"
          title={t("athlete-portal:programs.confirmPush")}
        >
          <div className="body">
            {clientOnProgram && (
              <div className="push-warning" role="alert">
                <strong>
                  {t(`athlete-portal:programs.pushWarn.${clientOnProgram}.title`, {
                    name: ath?.name,
                  })}
                </strong>
                <p>
                  {t(`athlete-portal:programs.pushWarn.${clientOnProgram}.secondary`)}
                </p>
                <p>
                  {t(`athlete-portal:programs.pushWarn.${clientOnProgram}.howTo`)}
                </p>
              </div>
            )}
            <div className="columns">
              <div className="column" data-col="1/1">
                <h4>{t("athlete-portal:programs.byPushingConfirm")}</h4>
                <ul className="confirm-push-implications">
                  <li>{t("athlete-portal:programs.pushImplication1", { role })}</li>
                  <li>{t("athlete-portal:programs.pushImplication2")}</li>
                  <li>{t("athlete-portal:programs.pushImplication3", { role })}</li>
                </ul>
              </div>
            </div>
            <div className="foot mt-8">
              <div className="info">
                <h4 className="alt">
                  {t("athlete-portal:programs.setupReminder")}
                </h4>
                <ToolTip
                  id="reminder"
                  body={t("athlete-portal:programs.reminderTooltip", {
                    name: ath.name,
                  })}
                >
                  <SvgIcon src="/img/new-icons/question-circle.svg" />
                </ToolTip>
              </div>

              <DateInput
                name="date"
                altPosition
                placeholder={t("athlete-portal:programs.dueDate")}
                defaultValue={defaultDate.toDate()}
                min={moment()}
                alignRight="true"
              />
            </div>
          </div>

          <footer>
            <a
              role="button"
              data-button-type="secondary"
              data-action="cancel"
              className="cancel"
              href="/actions/refresh?modal="
            >
              {t("common:cancel")}
            </a>

            <button data-button-type="primary" type="submit">
              {t("common:confirm")}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

ConfirmPush.contextType = RillContext;

export default withTranslation(["athlete-portal", "common"])(ConfirmPush);
